import {Directive, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {CollapseControl} from "./smart-table.component";

@Directive({
  selector: '[smartTableNavigate]'
})
export class SmartTableNavigateDirective {

  @Input('smartTableNavigate') path: string[];
  @Input('collapseByClick') itemCollapse: CollapseControl;
  @Input() collapseAuto: boolean;

  @HostBinding('class.cursor-pointer') get onCursor() {
    return !!this.path || this.itemCollapse;
  }

  @HostListener("click", ['$event.target', '$event.ctrlKey', '$event.metaKey'])
  onClick(target, ctrlKey, metaKey) {
    if (!this.path && !this.itemCollapse) return;

    const stop = this.findBySelector(target, ['button', 'a', '.prevent-default']);

    if (!stop) {

      if (this.itemCollapse) {
        this.itemCollapse.toggle(this.collapseAuto);
      } else {
        try {
          if (ctrlKey || metaKey) {
            let url = this.router.createUrlTree(this.path, {relativeTo: this.route});
            window.open(url.toString(), '_blank');
          } else {
            this.router.navigate(this.path, {relativeTo: this.route});
          }
        } catch (e) {
          this.toastr.error(e);
        }
      }
    }
  }

  constructor(private elementRef: ElementRef,
              private route: ActivatedRoute,
              private router: Router,
              private toastr: ToastrService) { }

  findBySelector(target, selectors) {
    const listSelectors = Array.isArray(selectors) ? selectors : [selectors];

    if (target === this.elementRef.nativeElement) {
      return false;
    }

    for (let selector of listSelectors) {
      if (target.matches(selector)) {
        return true;
      }
    }

    target = target.parentNode;

    return this.findBySelector(target, selectors);
  }
}
